import { TokenIcon } from "@/components/token"
import { Badge } from "@/components/ui/badge"
import { Token } from "@/config/tokens"

export default function TokenBadge({ token }: { token: Token }) {
  return (
    <Badge
      variant="secondary"
      className="flex flex-row gap-2 font-normal text-sm w-fit"
    >
      <div className="w-4 h-4">
        <TokenIcon name={token} size={16} />
      </div>
      {token}
    </Badge>
  )
}
